module.exports = __webpack_public_path__ + "static/img/necklace.e034328.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/necklace.png
// module id = 0mkz
// module chunks = 0